import { render, staticRenderFns } from "./mokuai97.vue?vue&type=template&id=f4bad6ce&"
import script from "./mokuai97.vue?vue&type=script&lang=js&"
export * from "./mokuai97.vue?vue&type=script&lang=js&"
import style0 from "./mokuai97.vue?vue&type=style&index=0&id=f4bad6ce&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports